import {patchState, signalStoreFeature, withHooks} from "@ngrx/signals";
import {extractRelevantData} from "../../util/extract";
import {effect} from "@angular/core";
import {isDefined} from "../../../core/util/isDefined";

export function sessionSave<Store>( sessionStorageKey: string, stateKeys: ( keyof Store )[], entityUpdaterFunc?: string ) {

    return signalStoreFeature(
        withHooks((
            store
        )=>({

            onInit: () => {

                const stateValues: any = extractRelevantData(store as Store, stateKeys);
                const sessionValueString = sessionStorage.getItem(sessionStorageKey);
                let sessionValues = JSON.parse(sessionValueString);
                if( isDefined(entityUpdaterFunc) && isDefined(sessionValues) && sessionValues['entities']) {
                    (store as any)[entityUpdaterFunc](sessionValues['entities']);
                }

                patchState(store, sessionValues);

                effect(() => {

                    Object.values(stateValues); //effect invoker, this effect scope won't activate without this line

                    const sessionValueString = sessionStorage.getItem(sessionStorageKey);
                    const stateData: any = Object.entries(stateValues).reduce((acc, [key, value]) => { acc[key] = (value as any)(); return acc; }, {} as any);
                    const stateDataString = JSON.stringify(stateData);

                    if( stateDataString !== '{}' && sessionValueString !== stateDataString ){
                        sessionStorage.setItem( sessionStorageKey , stateDataString );
                    }

                });
            }
        }))
    );
}